export * from './date-localized.pipe';
